import React, { Component } from 'react';
import {
    PageContainer, PageHeader, HeaderContainer, 
    PageTitleContainer, PageTitle, 
    PageBody,    
} from "../component/PageComponent";

class Page404 extends Component {
    constructor(props){
        super(props);

        this.state = {
            pageCode: 404,
        }
    }

    render() {
        return (
            <PageContainer>
                <PageHeader>
                    <HeaderContainer>
                        <PageTitleContainer IsError>
                            <PageTitle FontSize={'1.1em'} FontSizeLarge={'1.2em'}>Error 404</PageTitle>                            
                        </PageTitleContainer>
                    </HeaderContainer>
                </PageHeader>
                <PageBody>
                    <h2 style={{color: '#002b70', width: '80%'}}>Oops sorry, Page not build yet</h2>
                </PageBody>
            </PageContainer>
        )
    }
}

export default Page404;